import React, { useEffect, useState } from "react";

// MUI
import Box from "@mui/material/Box";

// Components
import Loader from "../../components/loader/Loader";

// Services
import ProjectService from "../../services/ProjectService";

type Props = {
  historyId: number;
  handleModalClose: () => void;
};

const ProjectHistoryData = ({ historyId, handleModalClose }: Props) => {
  const [data, setData] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getHistoryData(id: number) {
      try {
        setIsLoading(true);
        const response = await ProjectService.getProjectHistoryData(id);
        setData(JSON.stringify(response, null, 2));
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        handleModalClose();
      }
    }

    getHistoryData(historyId);
  }, [historyId, handleModalClose]);

  return (
    <Box>
      {isLoading ? <Loader /> : null}
      {data ? <pre>{data}</pre> : null}
    </Box>
  );
};

export default ProjectHistoryData;
